import Logs from '@/components/Logs/index'
const Logspage = () => {
    const element = (<Logs />)
    return element
}
export default Logspage